<template>
	<div class="pa-2">
		<v-text-field
			v-model.trim="basic.name"
			:rules="[rules.required]"
			label="案件名(必須)"
			class="mt-4"
			outlined
			dense
		></v-text-field>

		<v-select
			v-model="basic.productCategory"
			label="商品区分(必須)"
			class="mt-4"
			:rules="[rules.required]"
			required
			outlined
			dense
			:items="categories"
			item-text="name"
			item-value="id"
			@change="setSubCategories"
		>
		</v-select>
		
		<v-select
			v-model="basic.productSubCategory"
			label="分類区分(必須)"
			:rules="[rules.required]"
			class="mt-4"
			outlined
			required
			dense
			:items="productSubCategories"
			item-text="name"
			item-value="id"
			no-data-text="商品区分を選択してください"
		>
		</v-select>

		<v-select
			v-model="basic.situation"
			label="受注確度(必須)"
			:rules="[rules.required]"
			class="mt-4"
			outlined
			required
			dense
			:items="situations"
			item-text="name"
			item-value="id"
		>
		</v-select>

		<v-select
			v-model="basic.team"
			label="チーム選択(必須)"
			:rules="[rules.required]"
			class="mt-4"
			outlined
			required
			dense
			:items="teams"
			item-text="name"
			item-value="id"
			@change="setTeamMembers"
		>
		</v-select>

		<v-select
			v-model="basic.teamMember"
			label="本件の担当者(必須)"
			:rules="[rules.required]"
			class="mt-4"
			outlined
			required
			dense
			:items="teamMembers"
			no-data-text="チームを選択してください"
			item-text="full_name"
			item-value="id"
		>
		</v-select>

		<div class="mt-4">
			<label class="text-body-2 font-weight-bold">成約したかどうか</label>
			<v-radio-group class="mt-1" row v-model="basic.contract">
				<v-radio
					v-for="(item, index) in contracts"
					:label="item.name"
					:key="`item-${index}`"
					:value="item.value"
					class="mr-2"
					dense
				/>
			</v-radio-group>
		</div>
		<div class="mt-4">
			<label class="text-body-2 font-weight-bold">流れ品かどうか</label>
			<v-radio-group class="mt-1" row v-model="basic.regularlySold">
				<v-radio
					v-for="(item, index) in regularlySolds"
					:label="item.name"
					:key="`item-${index}`"
					:value="item.value"
					class="mr-2"
					dense
				/>
			</v-radio-group>
		</div>

		<v-textarea
			v-model.trim="basic.description"
			class="mt-4"
			label="案件の概要"
			outlined
			dense
		></v-textarea>

		<v-textarea
			v-model.trim="basic.points"
			class="mt-4"
			label="進捗状況及び契約までのポイント"
			outlined
			dense
		></v-textarea>
	</div>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		basic: {
			type: Object,
			required: false,
			default: () => {},
		},
		categories: {
			type: Array,
			required: false,
			default: () => [],
		},
		teams: {
			type: Array,
			required: false,
			default: () => [],
		},
		situations: {
			type: Array,
			required: false,
			default: () => [],
		},
		subCategories: {
			type: Array,
			required: false,
			default: () => [],
		},
		teamUsers: {
			type: Array,
			required: false,
			default: () => [],
		},
		changeContract: {
			type: Boolean,
			required: false,
		},
	},
	data() {
		return {
			rules,
			productSubCategories: [],
			teamMembers: [],
			contracts: [
				{ name: "成約", value: true },
				{ name: "失注", value: false },
				{ name: "未定", value: null },
			],
			regularlySolds: [
				{ name: "流れ品である", value: true },
				{ name: "流れ品ではない", value: false },
			],
		}
	},
	methods: {
		setSubCategories() {
			const category = this.categories.find((category) => category.id == this.basic.productCategory)
			if (category) {
				this.productSubCategories = category.product_sub_categories
			}
			this.basic.productSubCategory = ""
		},
		setTeamMembers(team_id) {
			this.teams.forEach((team) => {
				if (team.id == team_id) {
					this.teamMembers = team.users
				}
			})
			// フルネームの作成
			this.teamMembers.forEach((member) => {
				const full_name = member["last_name"] + member["first_name"]
				member["full_name"] = full_name
			})
		},
	},
	computed: {
		setName: {
			get() {
				return this.basic.name
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setProductCategory: {
			get() {
				return this.basic.productCategory
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setProductSubCategory: {
			get() {
				return this.basic.productSubCategory
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setSituation: {
			get() {
				return this.basic.situation
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setTeam: {
			get() {
				return this.basic.team
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setTeamMember: {
			get() {
				return this.basic.teamMember
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setContract: {
			get() {
				return this.basic.contract
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setregularlySold: {
			get() {
				return this.basic.regularlySold
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setDescription: {
			get() {
				return this.basic.description
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
		setPoints: {
			get() {
				return this.basic.points
			},
			set(newValue) {
				return this.$emit("update:basic", newValue)
			},
		},
	},
	watch: {
		// 編集ページの際に事前にproductSubCategoriesをセット
		subCategories: {
			immediate: true,
			handler() {
				this.productSubCategories = this.subCategories
			},
		},
		// 編集ページの際に事前にteamMembersをセット
		teamUsers: {
			immediate: true,
			handler() {
				this.teamMembers = this.teamUsers
			},
		},
		'basic.contract': {
			handler(newValue, oldValue) {
				// 未定or失注から成約に切り替わったかチェック
				if (this.basic.contract === false || this.basic.contract === null) {
					this.basic.changeContract = false
				}
				if ((oldValue === false || oldValue === null) && newValue === true && this.basic.contract === true)
					this.basic.changeContract = true
			},
		},
	},
}
</script>
